import './index.scss';

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

class WFHistory {
    constructor(root) {
        this.root = root;
        this.mainNavLocked = false;
        this.mainNavUnlockTimer = null;
        this.decadeNavLocked = false;
        this.decadeNavUnlockTimer = null;

        let decadesSplide = this.root.querySelector('.splide-decades');
        if (decadesSplide) {
            this.decadesSplide = new Splide(decadesSplide, {
                autoWidth: true,
                gap: 0,
                padding: 0,
                arrows: false,
                pagination: false,
                isNavigation: true,
            }).mount();

            this.decadesSplide.on('click', this.onDecadeItemClick.bind(this));

            this.decadesSplideButtonPrev = this.root.querySelector('.splide-decades__arrow--prev');
            this.decadesSplideButtonNext = this.root.querySelector('.splide-decades__arrow--next');

            this.bindDecadeArrow(this.decadesSplideButtonPrev, this.onDecadePrevItemClick.bind(this));
            this.bindDecadeArrow(this.decadesSplideButtonNext, this.onDecadeNextItemClick.bind(this));

            this.decadesSplide.on('moved resized updated refreshed', () => {
                this.clearDecadeNavUnlockTimer();
                this.decadeNavLocked = false;
                this.syncDecadeArrowEnabled();
            });

            this.syncDecadeArrowEnabled();

            this.decadeEvent = false;
        }

        let mainSplide = this.root.querySelector('.splide-main');
        if (mainSplide) {
            this.mainSplide = new Splide(mainSplide, {
                autoWidth: true,
                gap: 0,
                padding: 0,
                arrows: false,
                pagination: false,
                // omitEnd: true,
            }).mount();

            this.mainSplide.on('active', this.onMainSplideChange.bind(this));

            this.mainSplideButtonPrev = this.root.querySelector('.splide-main__arrow--prev');
            this.mainSplideButtonNext = this.root.querySelector('.splide-main__arrow--next');

            this.bindMainArrow(this.mainSplideButtonPrev, '<');
            this.bindMainArrow(this.mainSplideButtonNext, '>');

            this.mainSplide.on('moved resized updated refreshed', () => {
                this.clearMainNavUnlockTimer();
                this.mainNavLocked = false;
                this.syncMainArrowVisibility();
            });

            this.syncMainArrowVisibility();
        }

        if (fsLightboxInstances) {
            for (var instanceKey in fsLightboxInstances) {
                let fsLightboxInstance = fsLightboxInstances[instanceKey];
                fsLightboxInstance.props.onOpen = function () {
                    let lbContainer = document.querySelector('.fslightbox-container');
                    if (!lbContainer) {
                        return;
                    }
                    if (lbContainer.classList.contains('wf-fslightbox-container')) {
                        return;
                    }

                    lbContainer.classList.add('wf-fslightbox-container');

                    let lbClose = document.createElement('button');
                    lbClose.classList.add('wf-fslightbox-close');
                    lbClose.innerHTML = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 26L26 2.00002" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><path d="M2 2L26 26" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>';

                    lbClose.addEventListener('click', () => {
                        fsLightboxInstance.close();
                    });

                    lbContainer.appendChild(lbClose);
                }
            }
        }
    }

    bindMainArrow(button, direction) {
        if (!button) {
            return;
        }

        button.addEventListener('click', (event) => {
            this.onMainArrowClick(event, direction);
        });
        // Extra guard against accidental double activation / zoom gestures.
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onMainArrowClick(event, direction) {
        event.preventDefault();

        if (this.mainNavLocked || this.mainSplide.Components.Controller.isBusy()) {
            return;
        }

        this.mainNavLocked = true;
        this.mainSplide.go(direction);

        // Unlock if Splide did not emit moved (e.g. already at end).
        this.clearMainNavUnlockTimer();
        this.mainNavUnlockTimer = window.setTimeout(() => {
            this.mainNavUnlockTimer = null;
            this.mainNavLocked = false;
            this.syncMainArrowVisibility();
        }, 450);
    }

    clearMainNavUnlockTimer() {
        if (this.mainNavUnlockTimer !== null) {
            window.clearTimeout(this.mainNavUnlockTimer);
            this.mainNavUnlockTimer = null;
        }
    }

    syncMainArrowVisibility() {
        if (!this.mainSplide) {
            return;
        }

        const controller = this.mainSplide.Components.Controller;
        const index = this.mainSplide.index;
        const end = controller.getEnd();

        this.setArrowVisible(this.mainSplideButtonPrev, index > 0);
        this.setArrowVisible(this.mainSplideButtonNext, index < end);
    }

    bindDecadeArrow(button, handler) {
        if (!button) {
            return;
        }

        button.addEventListener('click', (event) => {
            this.onDecadeArrowClick(event, handler);
        });
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onDecadeArrowClick(event, handler) {
        event.preventDefault();

        const button = event.currentTarget;
        if (
            !button
            || button.disabled
            || this.decadeNavLocked
            || this.decadesSplide.Components.Controller.isBusy()
        ) {
            return;
        }

        this.decadeNavLocked = true;
        handler(event);

        this.clearDecadeNavUnlockTimer();
        this.decadeNavUnlockTimer = window.setTimeout(() => {
            this.decadeNavUnlockTimer = null;
            this.decadeNavLocked = false;
            this.syncDecadeArrowEnabled();
        }, 450);
    }

    clearDecadeNavUnlockTimer() {
        if (this.decadeNavUnlockTimer !== null) {
            window.clearTimeout(this.decadeNavUnlockTimer);
            this.decadeNavUnlockTimer = null;
        }
    }

    syncDecadeArrowEnabled() {
        if (!this.decadesSplide) {
            return;
        }

        const index = this.decadesSplide.index;
        const end = this.decadesSplide.Components.Controller.getEnd();

        this.setArrowEnabled(this.decadesSplideButtonPrev, index > 0);
        this.setArrowEnabled(this.decadesSplideButtonNext, index < end);
    }

    setArrowVisible(button, visible) {
        if (!button) {
            return;
        }

        if (!visible && document.activeElement === button) {
            button.blur();
        }

        button.hidden = !visible;
        button.disabled = !visible;
        button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    setArrowEnabled(button, enabled) {
        if (!button) {
            return;
        }

        if (!enabled && document.activeElement === button) {
            button.blur();
        }

        button.hidden = false;
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        button.setAttribute('aria-hidden', 'false');
    }

    onDecadeItemClick(e) {
        let index = e.slide.dataset.index;
        this.setMainSliderIndex(parseInt(index));
    }

    onDecadeNextItemClick() {
        const currentIndex = this.decadesSplide.index;
        const length = this.decadesSplide.length;

        if (currentIndex < length - 1) {
            const nextIndex = currentIndex + 1;
            let nextSlide = this.decadesSplide.Components.Slides.getAt(nextIndex);
            let mainSliderNewIndex = nextSlide.slide.dataset.index;

            this.decadesSplide.go(nextIndex);
            this.setMainSliderIndex(parseInt(mainSliderNewIndex));
        }
    }

    onDecadePrevItemClick() {
        const currentIndex = this.decadesSplide.index;

        if (currentIndex > 0) {
            const newIndex = currentIndex - 1;
            let prevSlide = this.decadesSplide.Components.Slides.getAt(newIndex);
            let mainSliderNewIndex = prevSlide.slide.dataset.index;

            this.decadesSplide.go(newIndex);
            this.setMainSliderIndex(parseInt(mainSliderNewIndex));
        }
    }

    // Set main slider index from decade menu
    setMainSliderIndex(newIndex) {
        let currentIndex = this.mainSplide.index;
        if (newIndex > currentIndex) {
            let lastIndex = this.mainSplide.length - 1;
            let lastSlide = this.mainSplide.Components.Slides.getAt(lastIndex);
            if (!lastSlide.slide.classList.contains('is-visible')) {
                this.mainSplide.go(newIndex);
            }
        } else {
            this.mainSplide.go(newIndex);
        }
    }

    onMainSplideChange(e) {
        let index = e.index;
        let decadeSlides = this.root.querySelectorAll('.history-decade-menu .decade-item');
        for (let i = 0; i < decadeSlides.length; i++) {
            let slideElement = decadeSlides[i];
            const slideDataIndex = parseInt(slideElement.dataset.index);

            if (index == slideDataIndex) {
                this.decadesSplide.go(i);
                break;
            }

            if (slideDataIndex > index) {
                this.decadesSplide.go(i - 1);
                break;
            }
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.history').forEach((node) => {
        new WFHistory(node);
    });
});
